import { SvgIcon } from '@mui/material';
import { ReactComponent as CredicuotasSvg } from '../../../../assests/images/help/credicuotasHelp.svg';

// Inline y no como <img> para que el trazo tome `currentColor` e invierta los colores
// en hover/selección, igual que los íconos de MUI.
const CredicuotasIcon = (props) => (
  <SvgIcon {...props} component={CredicuotasSvg} inheritViewBox />
);

export default CredicuotasIcon;
